var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar-top'),_c('div',{staticClass:"body text-left"},[_c('div',{staticClass:"flex flex-no-wrap"},[_c('nav-bar'),_c('router-view')],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }